
 import * as React from 'react';
 import {createComponent, EventName} from '@lit/react';
 
 import {ObcToggleButtonVerticalGroup as ObcToggleButtonVerticalGroupElement} from '@oicl/openbridge-webcomponents/dist/components/toggle-button-vertical-group/toggle-button-vertical-group.js';
 
 
 

 
 export const ObcToggleButtonVerticalGroup = createComponent({
   react: React,
   tagName: 'obc-toggle-button-vertical-group',
   elementClass: ObcToggleButtonVerticalGroupElement,
   events: {
     
     onValue: 'value' as EventName<CustomEvent<{value: string, previousValue: string}>>,
   }
  });
 
 